/**
 * @author chuzhixin 1204505056@qq.com （不想保留author可删除）
 * @description router全局配置，如有必要可分文件抽离，其中asyncRoutes只有在intelligence模式下才会用到，vip文档中已提供路由的基础图标与小清新图标的配置方案，请仔细阅读
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/vab/layouts'
import { publicPath, routerMode } from '@/config'

Vue.use(VueRouter)
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/logout',
    component: () => import('@/views/logout'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/403'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    meta: {
      hidden: true,
    },
  },
]

export const asyncRoutes = [
  {
    path: '/',
    name: 'Root',
    component: Layout,
    meta: {
      title: 'トップ',
      icon: 'home-2-fill',
      breadcrumbHidden: true,
      levelHidden: true,
    },
    children: [
      {
        path: 'PWS01G03',
        name: 'PWS01G03',
        component: () => import('@/views/pws/PWS01G03'),
        meta: {
          title: 'トップ',
          // icon: 'home-2-fill',
          affix: true,
          noClosable: true,
          cname: 'rc',
        },
      },
    ],
  },
  {
    path: 'pws',
    name: 'pws',
    meta: {
      title: '日程調整（工事・診断）',
    },
    component: Layout,
    children: [
      {
        path: 'PWS02G01',
        name: 'PWS02G01',
        component: () => import('@/views/pws/PWS02G01.vue'),
        meta: {
          title: '日程調整',
          cname: 'sc',
          // icon: 'briefcase-5-fill',
        },
      },
      {
        path: 'PWS02G05',
        name: 'PWS02G05',
        component: () => import('@/views/pws/PWS02G05.vue'),
        meta: {
          title: '作業可能日調整',
          cname: 'sc',
          // icon: 'building-2-fill',
        },
      },
      {
        path: 'PWS02G02',
        name: 'PWS02G02',
        component: () => import('@/views/pws/PWS02G02.vue'),
        meta: {
          title: '日程回答',
          cname: 'sc',
          hidden: true,
        },
      },
      {
        path: 'PWS02G03',
        name: 'PWS02G03',
        component: () => import('@/views/pws/PWS02G03.vue'),
        meta: {
          title: '日程回答（工事）',
          cname: 'sc',
          hidden: true,
        },
      },
      {
        path: 'PWS02G04',
        name: 'PWS02G04',
        component: () => import('@/views/pws/PWS02G04.vue'),
        meta: {
          title: '見積書等提出',
          cname: 'sc',
          hidden: true,
        },
      },
      {
        path: 'DWS03G04',
        name: 'DWS03G04',
        component: () => import('@/views/pws/DWS03G04.vue'),
        meta: {
          title: '資料連携',
          cname: 'sc',
          hidden: true,
        },
      },
      {
        path: 'PWS03G02',
        name: 'PWS03G02',
        hidden: true,
        component: () => import('@/views/pws/PWS03G02.vue'),
        meta: {
          title: '報告書提出',
          hidden: true,
          cname: 'sc',
        },
      },
      {
        path: 'PWS02G06',
        name: 'PWS02G06',
        hidden: true,
        component: () => import('@/views/pws/PWS02G06.vue'),
        meta: {
          title: '作業可能日回答',
          hidden: true,
          cname: 'sc',
        },
      },
    ],
  },
  {
    path: 'rep',
    name: 'rep',
    meta: {
      title: '報告書（工事・診断）',
    },
    component: Layout,
    children: [
      {
        path: 'PWS03G01',
        name: 'PWS03G01',
        component: () => import('@/views/pws/PWS03G01.vue'),
        meta: {
          title: '工事・作業状況',
          cname: 'sc',
          // icon: 'building-2-fill',
        },
      },
    ],
  },
  {
    path: 'pwr',
    name: 'pwr',
    component: Layout,
    meta: {
      title: '日程調整（点検・清掃）',
      breadcrumbHidden: true,
      levelHidden: false,
    },
    children: [
      {
        path: 'PWR01G01',
        name: 'PWR01G01',
        component: () => import('@/views/pwr/PWR01G01.vue'),
        meta: {
          title: '作業予定',
          cname: 'rc',
        },
      },
      {
        path: 'PWR01G02',
        name: 'PWR01G02',
        component: () => import('@/views/pwr/PWR01G02.vue'),
        meta: {
          title: '発注詳細',
          cname: 'rc',
        },
      },
      {
        path: 'PWR01G03',
        name: 'PWR01G03',
        component: () => import('@/views/pwr/PWR01G03.vue'),
        meta: {
          title: '作業日程詳細',
          hidden: true,
          cname: 'rc',
        },
      },
      {
        path: 'PWR01G04',
        name: 'PWR01G04',
        component: () => import('@/views/pwr/PWR01G04.vue'),
        meta: {
          title: '作業日程変更',
          hidden: true,
          cname: 'rc',
        },
      },
    ],
  },
  {
    path: 'report',
    name: 'report',
    component: Layout,
    meta: {
      title: '報告書（点検・清掃）',
      breadcrumbHidden: true,
      levelHidden: false,
    },
    children: [
      {
        path: 'PWR02G04',
        name: 'PWR02G04',
        component: () => import('@/views/pwr/PWR02G04.vue'),
        meta: {
          title: '作業実績',
          cname: 'rc',
        },
      },
      {
        path: 'PWR02G05',
        name: 'PWR02G05',
        component: () => import('@/views/pwr/PWR02G05.vue'),
        meta: {
          title: '作業報告書',
          cname: 'rc',
        },
      },
      {
        path: 'PWR02G06',
        name: 'PWR02G06',
        component: () => import('@/views/pwr/PWR02G06.vue'),
        meta: {
          title: '作業報告書提出',
          hidden: true,
          cname: 'rc',
        },
      },
      {
        path: 'PWR02G06_RO',
        name: 'PWR02G06_RO',
        component: () => import('@/views/pwr/PWR02G06_RO.vue'),
        meta: {
          title: '作業報告書提出',
          hidden: true,
          cname: 'rc',
        },
      },
    ],
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
]

const router = createRouter()

function fatteningRoutes(routes) {
  return routes.flatMap((route) => {
    return route.children ? fatteningRoutes(route.children) : route
  })
}

export function resetRouter(routes = constantRoutes) {
  routes.map((route) => {
    if (route.children) {
      route.children = fatteningRoutes(route.children)
    }
  })
  router.matcher = createRouter(routes).matcher
}

function createRouter(routes = constantRoutes) {
  return new VueRouter({
    base: publicPath,
    mode: routerMode,
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: routes,
  })
}

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

export default router
